"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _AppNativeStorage = _interopRequireDefault(require("../../utils/AppNativeStorage"));

var _ArrayHelper = require("../../helpers/ArrayHelper");

var WriteOnlyStore = /*#__PURE__*/function () {
  function WriteOnlyStore(nativeStorageKey) {
    var defaultData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, WriteOnlyStore);
    this.nativeStorageKey = nativeStorageKey;
    this.defaultData = this._makeCopy(defaultData);
    this.persistentData = this._makeCopy(defaultData);
    this.writeOrder = [];
    this.storeReady = false;
  }

  (0, _createClass2["default"])(WriteOnlyStore, [{
    key: "_makeCopy",
    value: function _makeCopy(json) {
      return JSON.parse((0, _stringify["default"])(json));
    }
  }, {
    key: "loadFromNativeStorage",
    value: function () {
      var _loadFromNativeStorage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("loading data from native storage with key ".concat(this.nativeStorageKey));
                _context.prev = 1;
                _context.next = 4;
                return _AppNativeStorage["default"].getValue(this.nativeStorageKey);

              case 4:
                this.persistentData = _context.sent;
                console.log('data loaded from native storage: ', JSON.parse((0, _stringify["default"])(this.persistentData)));
                this.persistentData = this.persistentData || this.defaultData;
                this.storeReady = true;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                console.log('error retrieving data from native storage. Not yet available?', _context.t0);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10]]);
      }));

      function loadFromNativeStorage() {
        return _loadFromNativeStorage.apply(this, arguments);
      }

      return loadFromNativeStorage;
    }()
    /**
     * Accepts only serializable json and throws an exception if something else is given
     */

  }, {
    key: "setData",
    value: function () {
      var _setData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(json) {
        var start, releaseFn, copy, duration;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                start = (0, _now["default"])();
                _context2.next = 3;
                return (0, _ArrayHelper.waitForTurn)(this.writeOrder);

              case 3:
                releaseFn = _context2.sent;
                _context2.prev = 4;
                copy = this._makeCopy(json);
                _context2.next = 8;
                return _AppNativeStorage["default"].saveValue(this.nativeStorageKey, copy);

              case 8:
                this.persistentData = copy;
                duration = (0, _now["default"])() - start;

                if (duration > 300) {
                  console.warn("writing to ".concat(this.nativeStorageKey, " took ").concat((0, _now["default"])() - start, " ms"));
                }

                releaseFn();
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](4);
                console.error("error writing to ".concat(this.nativeStorageKey), _context2.t0, json);
                releaseFn();

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 14]]);
      }));

      function setData(_x) {
        return _setData.apply(this, arguments);
      }

      return setData;
    }()
  }, {
    key: "getData",
    value: function getData() {
      return this.persistentData;
    }
  }]);
  return WriteOnlyStore;
}();

var _default = WriteOnlyStore;
exports["default"] = _default;